const tools = require('utilities/tools');

export default {
    /**
     * Genera una direccion a partir de sus componentes. Dado que `town` es opcional y `province` es requerido, si no se
     * especifica un valor para `town` se utilizara el descriptivo de la provincia en su lugar. Esto es especialmente util
     * para el backend porque no guarda la provincia sino el town cuando se le envia la direccion del Courier.
     */
    generateFormattedAddress(nameOfRoad, addressNumber, postalCode, town, province, country, cities, countries) {
        if (cities == null || countries == null) {
            throw new Error(
                'addressHelper::generateFormattedAddress -> cities or countries cannot be null or undefined.'
            );
        }
        let address;

        const countryDescriptor = countries.find(c => c.get('value') === country);
        const countryName = tools.isEmpty(countryDescriptor) ? '' : countryDescriptor.get('label');

        if (tools.isEmptyOrWhitespace(town)) {
            const provinceDescriptor = cities.find(c => c.get('value') === province);
            const provinceName = tools.isEmpty(provinceDescriptor) ? '' : provinceDescriptor.get('label');

            address = `${nameOfRoad}, ${addressNumber}, ${postalCode}, ${provinceName}, ${countryName}`;
        } else {
            address = `${nameOfRoad}, ${addressNumber}, ${postalCode}, ${town}, ${countryName}`;
        }

        return address;
    },
};
